import React, { useEffect, useState, useMemo } from "react";
import {
    Box,
    Typography,
    Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import usePermissionDataStore from "../../Zustand/Store/usePermissionDataStore";
import { hasCrudOrAllPermission } from "../../Utils/organizationPermissions";

const Layout4 = ({
    heading,
    Route,
    btnName,
    showAddButton = true,
    add_action
}) => {

    const navigate = useNavigate();
    const { Permission } = usePermissionDataStore();

    // Check if user has ADD permission
    const hasAddPermission = useMemo(() => {
        if (!add_action) return false;
        return hasCrudOrAllPermission(Permission, add_action);
    }, [add_action, Permission]);

    return (
        <Box p={4}>
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">{heading}</Typography>
                {showAddButton && btnName && hasAddPermission && (
                    <Button variant="contained" onClick={() => navigate(`${Route}/add`)}>
                        {btnName}
                    </Button>
                )}
            </Box>


        </Box>
    );
};

export default Layout4;
